<template>
    <div v-if="data.image" class="flex pb-6 justify-center">
        <a v-if="data.url" :href="data.url" target="_blank">
            <img loading="lazy" :src="data.image" class="max-w-full rounded-md" />
        </a>
        <img v-else loading="lazy" :src="data.image" class="max-w-full rounded-md" />
    </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
